import { createReducer } from '../utils/helpers';
import getParameterFromUrl from '../utils/getParameterFromUrl';
import {
  OPEN_MENU,
  CLOSE_MENU,
  OPEN_APP_STEPS,
  CLOSE_APP_STEPS,
} from '../actions/appStateActions'

const initialState = {
  isOpenMenu: false,
  isOpenAppSteps: true,
  isAgeAbtest: getParameterFromUrl('ageAbtest') === 'true',
  isExtraSteps: getParameterFromUrl('extraSteps') === 'true',
  forGender: getParameterFromUrl('forGender'),
  isWithMail: getParameterFromUrl('withMail'),
  isAgeManTest: getParameterFromUrl('ageManTest') === 'true',
}

const appStateReducer = createReducer(initialState, {
  [OPEN_APP_STEPS.REQUEST]: state => {
    return {
      ...state,
      isOpenAppSteps: true,
    }
  },
  [CLOSE_APP_STEPS.REQUEST]: state => {
    return {
      ...state,
      isOpenAppSteps: false,
    }
  },
  [OPEN_MENU.REQUEST]: state => {
    return {
      ...state,
      isOpenMenu: true,
    }
  },
  [CLOSE_MENU.REQUEST]: state => {
    return {
      ...state,
      isOpenMenu: false,
    }
  },
})

export default appStateReducer
